<template>
  <v-container>
    <v-layout justify-center row>
      <v-flex sm8 md6 lg5>
        <v-form @submit.prevent="onSubmit" novalidate class="elevation-2 pa-3">
          <Fields
            v-bind="{fields, object: formData, errors: formErrors}"
            />

          <v-btn type="submit" color="primary">Zapisz</v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {updateTrainer} from './api'
import Fields from '@/forms/Fields'
import formMixin from '@/utils/formMixin'
import _ from 'lodash'

export default {
  components: {Fields},
  mixins: [formMixin],
  props: {
    trainerData: {
      type: Object
    }
  },
  computed: {
    fields () {
      return [
        {comp: 'text', id: 'first_name', label: 'Imię:'},
        {comp: 'text', id: 'last_name', label: 'Nazwisko:'}
      ]
    },
    message () {
      return 'Konto trenera zostało edytowane.'
    }
  },
  created () {
    this.formData = _.cloneDeep(this.trainerData)
  },
  methods: {
    submit (data) {
      return updateTrainer(data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/trainers/TrainerUpdateForm.vue